import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getReplaceHorseSlice = createSlice({
    name: 'ReplaceHorse',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchReplaceHorse.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchReplaceHorse.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchReplaceHorse.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setReplaceHorse , setStatus} = getReplaceHorseSlice.actions;
export default getReplaceHorseSlice.reducer;

export const fetchReplaceHorse = createAsyncThunk('/ReplaceHorseget/fetch', async({id,idtobereplace}) => {
    const res = await axios.put(`${window.env.API_URL}/ReplaceHorse/${id}/${idtobereplace}`);
    const ReplaceHorseData = res.data;
    return ReplaceHorseData;
})